import React, {useContext} from 'react'
import {useParams} from 'react-router-dom'
import {WindowPopup} from "../components/WindowPopup"
import config from "../config.json"
import {
    getAuthHeader,
    getItems,
    getLocalStorageItem,
    objectLang,
    removeCookieOfFolderId,
    setLocalStorageItem
} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {useHttp} from "../hooks/http.hook"
import {LoaderClass} from "../elements/LoaderClass"
import {LinksClass} from "../components/LinksClass";

export const NoteRenamePage = () => {
    setLocalStorageItem('page', 'NoteRenamePage')

    const lang = objectLang().language

    const host =
        window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()

    const { id } = useParams()
    const data = {
        noteId: id,
        oldName: new URLSearchParams(window.location.search).get('name') || '',
        typeData: 'note-rename',
        thumb: new URLSearchParams(window.location.search).get('thumb') || '',
        link: {from: new URLSearchParams(window.location.search).get('from') || 'us-link.cloud'}
    }
    const parent = new URLSearchParams(window.location.search).get('parent') || `${auth.rootFolder}`

    const onRename = async (name) => {
        if (!name) return
        try {
            await request(
                `${host}/api/note/rename/${id}`,
                'POST',
                {
                    id,
                    name: name
                },
                {
                    Authorization: getAuthHeader(auth),
                    'Content-Type': 'application/json'
                })

            removeCookieOfFolderId(parent)
            window.location.replace(`/${lang.lang}/folder/open/${parent}`)

        } catch (e) {
            window.location.replace(`/${lang.lang}/`)
        }
    }

    if (loading) {
        return <LoaderClass />
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            {data && (
                <WindowPopup data={data} lang={lang} title={lang.body.noteRenamePage.title} onRename={onRename} />
            )}
        </>
    )
}